import { filter, isNil, includes, prop } from 'ramda';

const ROLES = Object.freeze({
  superAdmin: 'superAdmin',
  admin: 'admin',
  offerEditor: 'offerEditor',
  regular: 'regular',
  qa: 'qa'
});

const TEAM_ROLES = [{
  label: 'Super Admin',
  value: ROLES.superAdmin,
  color: 'flexi-super-admin'
}, {
  label: 'Administrateur',
  value: ROLES.admin,
  color: 'flexi-admin'
}, {
  label: 'Éditeur d\'offre',
  value: ROLES.offerEditor,
  color: 'flexi-offer-editor'
}, {
  label: 'Lecteur',
  value: ROLES.regular,
  color: 'flexi-regular'
},
{
  label: 'QA',
  value: ROLES.qa,
  color: 'flexi-qa'
}];

const ITEM_ROLES = itemType => filter(
  role => isNil(itemType) || includes(itemType, prop('itemTypes', role))
)([{
  label: 'Éditeur',
  value: 'editor',
  itemTypes: ['document']
}, {
  label: 'Éditeur des variables techniques',
  value: 'techEditor',
  itemTypes: ['document']
}, {
  label: 'Lecteur',
  value: 'reader',
  itemTypes: ['document']
}, {
  label: 'Valideur du document',
  value: 'documentValidator',
  itemTypes: ['document']
}, {
  label: 'Inactif',
  value: 'inactive',
  itemTypes: ['document']
}, {
  label: 'Valideur d\'offre',
  value: 'offerValidator',
  itemTypes: ['offer']
}]);

export {
  ROLES,
  TEAM_ROLES,
  ITEM_ROLES
};
